"use client";
import { MoonIcon, SunIcon } from "./icons";
import { siteCopy } from "./site";
import { useTheme } from "./useTheme";

/**
 * One button, not two. It shows the theme you would switch to and says so in its label,
 * which is what people expect from a single-control toggle.
 */
export function ThemeSwitch() {
  const { theme, setTheme } = useTheme();
  const t = siteCopy.theme;
  const next = theme === "dark" ? "light" : "dark";

  return (
    <button
      type="button"
      title={next === "dark" ? t.dark : t.light}
      aria-label={next === "dark" ? t.dark : t.light}
      onClick={() => setTheme(next)}
      className="grid size-8 cursor-pointer place-items-center rounded-full text-fg-muted transition-colors duration-200 hover:bg-bg-sunk hover:text-fg"
    >
      {next === "dark" ? <MoonIcon /> : <SunIcon />}
    </button>
  );
}
